module.exports = __webpack_public_path__ + "static/cosyzebramain-f62ec512eb1dd14a1487fa5fa3e62f88.png";